export const SettingTimePluginSettings: IPluginSettings = {
    name: 'Установка временных интервалов',
    mnemocode: 'setting_time_plugin',
    columns: []
  }